module.exports = __webpack_public_path__ + "static/media/criativos_feminino_roupas.1b6955fb.jpg";